const doNotAcceptEmptyStringOrSlashes = '^(?!\\s*$)[^/\\\\]+$';

export { doNotAcceptEmptyStringOrSlashes };
